import { createContext, useContext } from "react";

export type Point = { readonly x: number; readonly y: number };

export const AskHere = createContext<((at: Point) => void) | undefined>(undefined);

export const useAskHere = (): ((at: Point) => void) | undefined => useContext(AskHere);

export function pointUnder(element: Element): Point {
  const { left, bottom } = element.getBoundingClientRect();
  return { x: left, y: bottom + 4 };
}
